import $ from 'jquery';
import focusLock from 'dom-focus-lock';

function initPopup() {
  $('a.open-modal').click(function () {
    $(this).modal({
      fadeDuration: 250,
      showSpinner: false,
      blockerClass: 'c-popup-blocker',
      modalClass: 'c-popup',
      closeClass: 'c-popup__close',
      showClose: false,
    });

    return false;
  });

  $('.accommodation-type__popup-close').click(() => {
    $.modal.close();
  });
}

function initPopupResidences() {
  $('a.open-modal-residences').click(function () {
    $(this).modal({
      fadeDuration: 250,
      showSpinner: false,
      blockerClass: 'c-popup-blocker',
      modalClass: 'c-popup',
      closeClass: 'c-popup__close',
      showClose: false,
    });

    return false;
  });
}

$(document).ready(() => {
  initPopup();
  initPopupResidences();

  $('.c-popup').on($.modal.BEFORE_OPEN, (event, modal) => {
    $('header, main, footer').attr('aria-hidden', 'true');
    focusLock.on(modal.$elm['0']);
  })
    .on($.modal.OPEN, (event, modal) => {
      modal.$elm.find('.c-popup__close').focus();
    })
    .on($.modal.BEFORE_CLOSE, (event, modal) => {
      $('header, main, footer').removeAttr('aria-hidden');
      focusLock.off(modal.$elm['0']);
    })
    .on($.modal.AFTER_CLOSE, (event, modal) => {
      modal.$anchor.focus();
    });
});
